import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { type GigData } from '@fiverr-private/seller_pages_toolbox';
import { useSellerRole } from '../../hooks/useSellerRole';
import { gigsAtom } from '../../atoms';
import { orderGigs } from './utils';

export const useGigsRoleFiltered = (sellerRoleId?: string) => {
    const sellerRole = useSellerRole(sellerRoleId);
    const gigs = useAtomValue(gigsAtom);
    const gigsRoleFiltered = useMemo(() => {
        if (!sellerRole) {
            return gigs;
        }
        return gigs.filter((gig) => sellerRole.gigs.find((roleGig) => roleGig.id === gig.gig_id.toString()));
    }, [gigs, sellerRole]);

    return gigsRoleFiltered;
};

export const useGigsOrdered = (sellerRoleId?: string) => {
    const gigsRoleFiltered = useGigsRoleFiltered(sellerRoleId);
    const gigsOrdered = useMemo(() => {
        const relevantGigsOrder: number[] = gigsRoleFiltered.map((item) => item.gig_id);
        return orderGigs(gigsRoleFiltered, relevantGigsOrder);
    }, [gigsRoleFiltered]);

    return gigsOrdered;
};

export const useGigsSliced = (gigs: GigData[], showAllGigs: boolean, countCollapsed: number) =>
    useMemo(() => (showAllGigs ? gigs : gigs.slice(0, countCollapsed)), [gigs, showAllGigs, countCollapsed]);
